<template>
  <b-button
    class="btn-icon"
    variant="flat"
    v-b-tooltip.hover.variant.bottom
    title="Delete"
    @click="httpDelete"
  >
    <b-icon icon="trash" />
  </b-button>
</template>

<script>
import DomainEventBus from '@/xvisor/bus/DomainEventBus';

export default {
  props: {
    domain: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      deleteDomainUrl: '/policysettings/unauthorizedDomain',
    };
  },
  computed: {
    deleteDomainForm() {
      return { unauthorizedDomain: this.domain };
    },
  },
  methods: {
    httpDelete() {
      this.$http
        .delete(this.deleteDomainUrl, { data: this.deleteDomainForm })
        .then(() => {
          this.$bvToast.toast('Successfully deleted Domain', { variant: 'success' });
          DomainEventBus.$emit('changed');
        })
        .catch(() => {
          this.$bvToast.toast('Failed to delete Domain', { variant: 'danger' });
        });
    },
  },
};
</script>
